import React from 'react';
import parser from 'html-react-parser';
import { Icon } from '../../../../components';
import { Container } from './styles';
import { SeparatorLine } from '@/presentation/components/Schedule/components/CourseDetail';
import useIsMobile from '@/presentation/hooks/useIsMobile';

interface ContentModalTwoButtonsProps {
  img: any;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  subtitle0?: string | React.ReactNode;
  showInfo: boolean;
  info?: any;
  textButton1: string;
  align?: 'center' | 'left';
  onClickButton1: () => void;
  textButton2: string;
  onClickButton2: () => void;
  onRow?: boolean;
  withSeparator?: boolean;
}
const ContentModalTwoButtons = (props: ContentModalTwoButtonsProps) => {
  const {
    img,
    title,
    subtitle,
    subtitle0,
    showInfo,
    info,
    textButton1,
    onClickButton1,
    textButton2,
    onClickButton2,
    align,
    onRow,
    withSeparator
  } = props;
  const style: any = { textAlign: align };
  const isMobile = useIsMobile(true);
  const widthBtnASeparator = isMobile ? '100%' : '151px';
  const widthBtnBSeparator = isMobile ? '100%' : '212px';
  return (
    <Container
      data-testid="cmp-content-moda-two-buttons"
      withSeparator={withSeparator}
      flexDirection={onRow}
    >
      {img && <img src={img} alt="image" aria-hidden="true" />}
      <span className="contentTitle">
        {typeof title === 'string' ? parser(title) : title}
      </span>
      {subtitle0 && <p className="contentSubtitle0">{subtitle0}</p>}
      {subtitle && !withSeparator && (
        <div className="contentSubtitle" style={style}>
          {typeof subtitle === 'string' ? parser(subtitle) : subtitle}
        </div>
      )}
      {showInfo && info && (
        <div className="contentInfo">
          <Icon name="info" size={15} />
          <span className="contentInfoText">{info}</span>
        </div>
      )}
      <div
        className={
          !withSeparator ? 'buttonContainers' : 'buttonContainersColumn'
        }
      >
        <button
          style={{ maxWidth: withSeparator ? widthBtnASeparator : '' }}
          className="contentButton"
          data-testid="cmp-content-modal-two-button1-onclick"
          type="button"
          onClick={onClickButton1}
        >
          {textButton1}
        </button>
        {withSeparator && subtitle && (
          <>
            <SeparatorLine color="#7A959F" />
            <div className="contentSubtitle" style={style}>
              {typeof subtitle === 'string' ? parser(subtitle) : subtitle}
            </div>
          </>
        )}
        <button
          style={{ maxWidth: withSeparator ? widthBtnBSeparator : '' }}
          className="contentButton2"
          data-testid="cmp-content-modal-two-button2-onclick"
          type="button"
          onClick={onClickButton2}
        >
          {textButton2}
        </button>
      </div>
    </Container>
  );
};

ContentModalTwoButtons.defaultProps = {
  subtitle0: '',
  subtitle: '',
  info: '',
  align: 'center'
};
export default ContentModalTwoButtons;
